import { render, staticRenderFns } from "./OrgProfileEditPage.vue?vue&type=template&id=28ef54fa&"
import script from "./OrgProfileEditPage.vue?vue&type=script&lang=js&"
export * from "./OrgProfileEditPage.vue?vue&type=script&lang=js&"
import style0 from "./OrgProfileEditPage.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports